module.exports = __webpack_public_path__ + "21fdbfa660ac6442f7254467c3115682.png";